/**
 * Cams API
 * Cams
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface MemberSummary { 
    userId?: number;
    memberId?: string | null;
    fullName?: string | null;
    emailAddress?: string | null;
    phoneNumber?: string | null;
    countryCode?: string | null;
    status?: string | null;
    isActive?: boolean;
    isOwner?: boolean;
    isUserLockedOut?: boolean;
    isKycDone?: boolean | null;
    isMobileVerified?: boolean | null;
    isEmailVerified?: boolean | null;
    address?: string | null;
    dateOfBirth?: string | null;
    type?: string | null;
    groupId?: number | null;
    groupName?: string | null;
    referenceId?: string | null;
    hasAutoDebitAccount?: boolean | null;
    defaultAutoDebitAccountName?: string | null;
    readonly noOfLoans?: number;
    noOfOutstandingLoans?: number;
    noOfBadStandingLoans?: number;
    noOfLoanApplications?: number;
}

